//#region src/modules/ServicePeriods/instance/instance-card-status.ts
function instanceCardStatus(instance, nowIso) {
	if (instance.endsAt <= nowIso) return "ended";
	if (instance.startsAt <= nowIso) return "active";
	return "upcoming";
}
var INSTANCE_CARD_STATUS_TAG = {
	active: {
		value: "Active",
		variant: "positive"
	},
	ended: {
		value: "Ended",
		variant: "neutral"
	},
	upcoming: {
		value: "Upcoming",
		variant: "info"
	}
};
var INSTANCE_CARD_STATUS_BORDER = {
	active: "positive",
	ended: "neutral",
	upcoming: "neutral"
};
//#endregion
export { INSTANCE_CARD_STATUS_BORDER, INSTANCE_CARD_STATUS_TAG, instanceCardStatus };

//# sourceMappingURL=instance-card-status.js.map